import { render, staticRenderFns } from "./Dialog1.vue?vue&type=template&id=a813f00e&scoped=true&"
import script from "./Dialog1.vue?vue&type=script&lang=js&"
export * from "./Dialog1.vue?vue&type=script&lang=js&"
import style0 from "./Dialog1.vue?vue&type=style&index=0&id=a813f00e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a813f00e",
  null
  
)

export default component.exports